import { render } from "./notam-list.vue?vue&type=template&id=1a012226"
import script from "./notam-list.vue?vue&type=script&lang=js"
export * from "./notam-list.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__